export const API_BASE_URL = process.env.API_BASE_URL;
export const SHIPMENT_CAL_BASE_URL = process.env.SHIPMENT_CAL_BASE_URL;
export const WEB_URL = process.env.URL;
export const NEXT_SHARP_PATH = '/tmp/node_modules/sharp';
export const NEW_GA_ID = process.env.GOOGLE_ANALYTICS_ID_NEW;
export const GA_ADS = process.env.GOOGLE_ADS_ID;
export const GA_TAG = process.env.GOOGLE_GA_TAG;
export const HSN_API = process.env.SEARCH_HSN;
// export const WORDPRESS_API = process.env.WORDPRESS_API;
export const YOUTUBE_CHANNEL_ID = process.env.YOUTUBE_CHANNEL;
export const YOUTUBE_VIDEO_API_KEY = process.env.YOUTUBE_VIDEO_API_KEY;
export const LINKEDIN_ID = process.env.LINKEDIN_ID
export const WORDPRESS_URL = process.env.WORDPRESS_URL;
export const WORDPRESS_API=WORDPRESS_URL+'/wp-json/wp/v2';
export const CLEVERTAP_ID = process.env.CLEVERTAP_ACCOUNT_ID;
export const REGION = process.env.NEXT_PUBLIC_CLEVERTAP_REGION;
export const GEOLOC_API = process.env.API_GEOLOCATION;
export const BUSINESS_LOAN_BASE_URL = process.env.CMS_PAGES_URL;
export const CMS_BASE_URL = process.env.CMS_BASE_URL;
export const ATOM_URL = process.env.ATOM_BASE_URL;
export const WHATSAPP_BASE_URL = process.env.WHATSAPP_BASE_URL;
export const TENDERSHARK_API_BASE_URL = process.env.TENDERSHARK_API_BASE_URL;
export const GST_SITEMAP_CMS_API = process.env.GST_SITEMAP_CMS_API;
export const CHATGPT_PIXEL_ID = process.env.CHATGPT_PIXEL_ID;

export const ENDPOINTS = {
  CONTACT_US_V1: API_BASE_URL + "/api/form/createForm", 
  CASE_STUDY_FORM: API_BASE_URL + '/api/form/createCaseStudyForm',
  //API for categories
  HSN_CATEGORIES_API: HSN_API + '/hsn/get-sections',
  // API for sub categories
  HSN_SUBCATEGORIES_API: HSN_API + '/hsn/get-chapters',
  // API to search hsn details by alphabet
  HSN_SEARCH_API: HSN_API + '/hsn/hsn-finder/search',

  HSN_CHAPTER_API: HSN_API + '/hsn/get-headings-by-chapter',
  HSN_CHAPTER_DETAIL_API: HSN_API + '/hsn/get-codes-by-heading',
  CREDLIX_BYPASS: API_BASE_URL + '/api/credlix/bypass',

  //Revised API for Search on Keypress

  HSN_SEARCH_KEYPRESS_API: HSN_API + '/hsn/search-hsn-codes',
  HSN_CODES_BY_MINISTRY:HSN_API + '/hsn/search-hsn-codes-by-ministry',
  MINISTRY_LIST_API:HSN_API + '/hsn/get-ministries',
  HSN_KEYWORDS_LIST_API: SHIPMENT_CAL_BASE_URL + '/hsn-codes/keywords',
  HSN_KEYWORDS_LIST_DETAIL_API: SHIPMENT_CAL_BASE_URL + '/hsn-codes/search',

  //Revised API for Click on Seach Results
  HSN_SEARCH_CLICK_API:HSN_API + '/hsn/get-codes-by-chapter',
  WORDPRESS_MEDIA:WORDPRESS_API + '/media',
  WORDPRESS_MAIN_API:WORDPRESS_API + '/posts',
  WORDPRESS_CAT_WITH_CATSLUG:WORDPRESS_API+'/categories',
  SITEMAP_BLOG_LINK:WORDPRESS_API + '/posts?categories=108',
  SITEMAP_NEWS_LINK:WORDPRESS_API + '/posts?per_page=100&categories=90',
  SITEMAP_EVENT_LINK:WORDPRESS_API + '/posts?per_page=100&categories=290',
  SITEMAP_CATEGORY_LINK:WORDPRESS_API + '/categories?exclude=153,290,90,108,341,1,110,109',
  WORDPRESS_BLOG_POST_LIST_WITH_IMAGE:WORDPRESS_API + '/posts?_embed&per_page=12&categories_exclude=153,290,90,350',
  WORDPRESS_BLOG_POST_LIST_WITH_IMAGE_ES:WORDPRESS_API + '/posts?_embed&per_page=12&categories=350', 
  WORDPRESS_CS_POST_LIST_WITH_IMAGE:WORDPRESS_API + '/posts?_embed&per_page=12&categories=153',
  WORDPRESS_NEWS_POST_LIST_WITH_IMAGE:WORDPRESS_API + '/posts?_embed&per_page=12&categories=90', 
  WORDPRESS_NEWS_POST_LIST_WITH_IMAGE_ES:WORDPRESS_API + '/posts?_embed&per_page=12&categories=351', 
  WORDPRESS_EVENTS_POST_LIST_WITH_IMAGE:WORDPRESS_API + '/posts?_embed&per_page=12&categories=290',
  WORDPRESS_ALL_CATEGORIES_API:WORDPRESS_API +  '/categories?exclude=350,153,290,90,108,341,1,110,109,354,355,356,357,358,359,360,366',
  WORDPRESS_ALL_CATEGORIES_API_INDUSTRY:WORDPRESS_API +  '/categories?exclude=350,337,153,290,90,108,341,1,110,109,71,340,81,344,347,351,342,343,345,346,348,349,361,364,365,370,371,372,440&orderby=id',
  // WORDPRESS_ALL_CATEGORIES_API_ES:WORDPRESS_API +  '/categories?exclude=350,337,153,290,90,108,341,1,110,109,71,340,81,344,347,351,354,355,356,357,358,359,360&orderby=id',
  WORDPRESS_ALL_CATEGORIES_API_ES:WORDPRESS_API +  '/categories?exclude=350,337,153,290,90,108,341,1,110,109,71,340,81,342,344,347,351,354,355,356,357,358,359,360,361,364,365,366,370,371,372,587&orderby=id',
  WORDPRESS_BLOG_POST_CATEGORY_LIST:WORDPRESS_API + '/posts?',
  SITEMAP_BLOG_ES:WORDPRESS_API + '/posts?categories=350&lang=es',

  // Author API Details
  WORDPRESS_AUTHOR_DETAIL_API:WORDPRESS_API + '/users',
  //Mexico Form API
  MEXICO_CONTACT_US: API_BASE_URL + "/api/form/createMexicoForm",
  //LEAD MAGNET Form API
  LEAD_MAGNET:  API_BASE_URL + "/api/form/createDomesticForm",

  //Business Loan Form API
  BUSINESS_LOAN:  API_BASE_URL + "/api/form/domesticBusinessLoanLead",
  GlobalBuyers:  API_BASE_URL + "/api/form/createGlobalBuyerForm",
  // Partner Program Form APi
  PARTNER_PROGRAM: API_BASE_URL + "/api/form/createPartnerProgramForm",

  // Shipment Calculator
  LCL_QUOTATION: SHIPMENT_CAL_BASE_URL + "/shipping_est/lcl-quotation",
  FCL_QUOTATION: SHIPMENT_CAL_BASE_URL + "/shipping_est/fcl-quotation",
  FETCHCOUNTRY: SHIPMENT_CAL_BASE_URL + "/shipping_est/country",
  FETCH_ORIGIN_PORT: SHIPMENT_CAL_BASE_URL + "/shipping_est/locode",
  HSN_CODE_GROUPS: SHIPMENT_CAL_BASE_URL + "/shipping_est/hsn-code-groups",
  HSN_CODE_GROUP_DETAILS: SHIPMENT_CAL_BASE_URL + "/shipping_est/hsn-code-group-details",
  USER_CREATE: SHIPMENT_CAL_BASE_URL + "/user",
  SHIPMENT_CONTAINERS: SHIPMENT_CAL_BASE_URL + "/shipping_est/containers",
  HSN_CODE_SEARCH: SHIPMENT_CAL_BASE_URL + "/shipping_est/hsn-codes",
  EXPORT_API: API_BASE_URL + '/api/form/export',
  // Business Laon Data
  BUSINESS_LOAN_API: BUSINESS_LOAN_BASE_URL + "/cms/get",
  KARZA_GST_API : API_BASE_URL + "/api/karza/get-gst-detail",
  BUYER_ELIGIBILITY_API: API_BASE_URL + "/api/form/create-buyer-eligibility-lead",
  PDF_GENERATE_API: API_BASE_URL + "/api/util/html2pdf",

  //HTSCODE
  HTS_CODE_API: BUSINESS_LOAN_BASE_URL + '/hts/',
  IMPORT_DUTY_API: BUSINESS_LOAN_BASE_URL + '/import-duty/',
  // India-Mexico Supplier Event Form
  INDIA_MEXICO_EVENT: API_BASE_URL + "/api/form/createLead",

  // Signup related endpoints
  SIGNUP_API: process.env.SIGNUP_API_URL,
  RESET_PASSWORD_API: process.env.RESET_PASSWORD_URL+"/users",
  FORGOT_PASSWORD_API: process.env.API_QA_URL+"users",

  // Credlix Finsights from CMS
  CREDLIX_FINSIGHTS: CMS_BASE_URL + '/cms/public/CREDLIX/posts?categorySlug=credlix-finsights&page=1&size=12',
  CREDLIX_FINSIGHTS_PAGINATED: (page = 1, size = 12) => CMS_BASE_URL + `/cms/public/CREDLIX/posts?categorySlug=credlix-finsights&page=${page}&size=${size}`,
  CREDLIX_FINSIGHTS_DETAIL: (slug) => CMS_BASE_URL + `/cms/public/CREDLIX/posts/${slug}`,

  //  GLOSSARY API RELATED
  GLOSSARY_API: CMS_BASE_URL + '/cms/public/CREDLIX/posts/v2?parentCategory=GLOSSARY&fetchAll=true&view=GLOSSARY',
  GLOSSARY_API_DETAIL: (slug) => CMS_BASE_URL + `/cms/public/CREDLIX/posts/${slug}`,
  RELATED_GLOSSARY_POST: (parentCategory,categorySlug) => CMS_BASE_URL + `/cms/public/CREDLIX/posts?parentCategory=${parentCategory}&categorySlug=${categorySlug}`,
  SEARCH_GLOSSARY_API: (searchTerm) => CMS_BASE_URL + `/cms/public/CREDLIX/posts/v2?parentCategory=GLOSSARY&fetchAll=true&view=GLOSSARY&search=${searchTerm}`,

  DOMESTIC_MEETING_SCHEDULER: ATOM_URL + 'calendar/anjali-ojha?source=CREDLIX&subSource=DOMESTIC',
  EXIM_MEETING_SCHEDULER: ATOM_URL + 'calendar/sahil-bajaj?source=CREDLIX&subSource=EXIM',

  // Direct API for creating lead in Credlix Onboarding
  CREATE_LEAD: process.env.CREATE_LEAD_URL + '/api/v2/create-lead',
  GENERATE_API_KEY: process.env.CREATE_LEAD_URL + '/api/v2/generate-key',
  HEADER_API_KEY: process.env.GENERATE_KEY_API_KEY,

  // LEADERSHIP_API
  LEADERSHIP_API: (pageName, groupKey) => CMS_BASE_URL + `/cms/public/${pageName}/content/leadership?groupKey=${groupKey}`,
  WHATSAPP_API: WHATSAPP_BASE_URL,

  // EXIM Document Validation API
  EXIM_DOCUMENT_VALIDATE_API:  API_BASE_URL + '/api/exim/validate-exim-document',

  GST_NUMBER_SEARCH_API:  TENDERSHARK_API_BASE_URL+ "/api/gst/",
  GST_SITEMAP_CMS_API: GST_SITEMAP_CMS_API+ "/api/cms-portal/gst-details?found=true&indexable=true&sortBy=RECENT&sortDir=desc",

  // BLOG POSTS AND CATEGORIES
  BLOG_CATEGORIES: CMS_BASE_URL + '/cms/public/CREDLIX/categories?parentCategory=BLOG',
  INDUSTRY_CATEGORIES: CMS_BASE_URL + '/cms/public/CREDLIX/categories?parentCategory=INDUSTRY',
  SPANISH_CATEGORIES: CMS_BASE_URL + '/cms/public/CREDLIX/categories?parentCategory=SPANISH_BLOG',
  GET_PARENT_CATEGORIES: CMS_BASE_URL + '/cms/public/CREDLIX/categories/parent',
  RELATED_BLOG_POST: (parentCategory,categorySlug) => CMS_BASE_URL + `/cms/public/CREDLIX/posts?parentCategory=${parentCategory}&categorySlug=${categorySlug}`,
  BLOG_INDUSTRY_POST: CMS_BASE_URL + '/cms/public/CREDLIX/posts?parentCategory=BLOG,INDUSTRY',
  SPANISH_POST: CMS_BASE_URL + '/cms/public/CREDLIX/posts?parentCategory=SPANISH_BLOG',
  BLOG_INDUSTRY_CATEGORIES: CMS_BASE_URL + '/cms/public/CREDLIX/categories?parentCategory=BLOG,INDUSTRY',
  BLOG_AUTHOR_API: (author) => CMS_BASE_URL + `/cms/public/CREDLIX/posts/authors/${author}`,
  
  WORDPRES_DOWNLOAD_PDF : [
    {
      id: 12226,
      pdf_link: 'https://cdnx1.moglix.com/docs/Exports+Customs+Clearance.zip',
      filename: 'Exports-Customs-Clearance.zip',
    },  
    {
      id: 14288,
      pdf_link: WORDPRESS_URL+'/wp-content/uploads/2025/01/Proforma-Invoice.pdf',
      filename: 'Proforma-Invoice.pdf',
    },
    {
      id: 14464,
     pdf_link: WORDPRESS_URL+'/wp-content/uploads/2025/01/Custom-Packing-List.pdf',
      filename: 'Custom-Packing-List.pdf',
    },
    {
      id: 14434,
      pdf_link: WORDPRESS_URL+'/wp-content/uploads/2025/01/Country-of-Origin-Certificate.pdf',
      filename: 'Country-of-Origin-Certificate.pdf',
    },
    {
      id: 14461,
     pdf_link: WORDPRESS_URL+'/wp-content/uploads/2025/01/Commercial-Invoice.pdf',
      filename: 'Commercial-Invoice.pdf',
    },
    {
      id: 14458,
     pdf_link: WORDPRESS_URL+'/wp-content/uploads/2025/01/Letter-of-credit.pdf',
      filename: 'Letter-of-credit.pdf',
    },
    {
      id: 14404,
     pdf_link: WORDPRESS_URL+'/wp-content/uploads/2025/01/Health-Certificates.pdf',
        filename: 'Health-Certificates.pdf',
    }
  ]
};
